import React from 'react';
export const SkeletonItemsList = ({ hierarchyView = false }) => (React.createElement("ul", { className: "list:none" }, ['40%', '56%', '41%', '78%', '36%', '52%'].map((w, i) => (React.createElement("li", { key: i, style: { padding: '0.5em 0 0.4375em' } },
    React.createElement("span", { className: "skeleton bdrs:2 d:block", style: {
            height: '1.25em',
            width: w,
            ...(hierarchyView && i > 0 && { marginLeft: '0.9375em' })
        } }))))));
